import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { checkIsMobile } from 'lib';
import PackageInfo from '../../package.json';

const initState = {
    menuPosition: localStorage.getItem('menuPosition') || 'left',
    isMobileView: false
};

const GlobalContext = createContext(initState);
export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalProvider = ({ children }) => {
    const [menuPosition, setMenuPosition] = useState(initState.menuPosition);
    const [isMobileView, setIsMobileView] = useState(initState.isMobileView);
    const [filterList, setFilterList] = useState([]);

    const onChangeMenuPosition = useCallback((value) => {
        localStorage.setItem('menuPosition', value);
        setMenuPosition(value);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(checkIsMobile() || window.innerWidth <= 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const tableVersion = localStorage.getItem('version');
        if (tableVersion !== PackageInfo.version) {
            for (let i = 0; i < localStorage.length; i += 1) {
                const key = localStorage.key(i);
                if (key.startsWith('table')) {
                    localStorage.removeItem(key);
                }
            }
            localStorage.setItem('version', PackageInfo.version);
        }
    }, []);

    return (
        <GlobalContext.Provider
            value={{
                menuPosition,
                setMenuPosition: onChangeMenuPosition,
                isMobileView,
                filterList,
                setFilterList
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};
